import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  UpdateCvRequest,
  Cv,
  CvDesignTemplateSampleResponse,
  CvDesignTemplateSample,
} from '@/../gen';

interface CvParams {
  id: number;
}

export const namespace = 'cv_design';
const actionCreator = actionCreatorFactory(namespace);
export const GetCv = actionCreator<{ cv_id: number }>('GET_CV');
export const GetCvDesignTemplateSamples = actionCreator<null>(
  'GET_CV_DESIGN_TEMPLATE_SAMPLES'
);
export const CvFetched = actionCreator<Cv>('CV_FETCHED');
export const UpdateCv = actionCreator<{
  params: CvParams;
  body: UpdateCvRequest;
}>('UPDATE_CV');
export const SetDesignTemplateSamples = actionCreator<
  CvDesignTemplateSampleResponse[]
>('SET_CV_DESIGN_TEMPLATE_SAMPLES');

export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cv: Cv;
  cvDesignTemplateSamples: CvDesignTemplateSample[];
}

const initialState = (): State => {
  return {
    cv: null,
    cvDesignTemplateSamples: [],
  };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCv, async function(context, action) {
      const { data } = await this.proffApi.getCv(action.payload.cv_id);
      context.commit(CvFetched(data.data.attributes));
    }),
    action(GetCvDesignTemplateSamples, async function(context) {
      const { data } = await this.proffApi.listCvDesignTemplateSamples();
      context.commit(SetDesignTemplateSamples(data.data));
    }),
    action(UpdateCv, async function(context, action) {
      const { params, body } = action.payload;
      const { data } = await this.proffApi.updateCv(params.id, body);
      context.commit(CvFetched(data.data.attributes));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(CvFetched, (state, action) => {
      state.cv = action.payload;
    }),
    mutation(SetDesignTemplateSamples, (state, action) => {
      state.cvDesignTemplateSamples = action.payload.map(
        item => item.attributes
      );
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cv: state => state.cv,
    cvDesignTemplateSamples: state => state.cvDesignTemplateSamples,
  },
};
